"use strict";

import utils from './blocks/_utils';
import Swal from 'sweetalert2'
import ContactModal from './blocks/_contact-modal';
import APIv2 from './blocks/_apiv2';
import feedbackUtil from './blocks/_feedback-util';
import {inlineEditor} from "./blocks/_inline-edit-multi";
import moment from "moment";
import {createApp} from 'vue';
import {Quasar,
    Notify} from "quasar/dist/quasar.esm.prod";
import IconSet from 'quasar/icon-set/material-icons';
//import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'
//import '../lib/material-icons-outlined/material-icons-outlined.css'
import { EventBus } from 'quasar'
import VirtualFieldsManager from "./components/VirtualFieldsManager";
import EntryFilesManager from "./components/EntryFilesManager";
import PhonesPrefixSuggester from "./components/PhonesPrefixSuggester";
import UserRestrictionsManager from "./components/UserRestrictionsManager.vue";

const bus = new EventBus()
window.bus = bus;
moment.locale(utils.currentLang());

require ('./blocks/_tinymces');
require ('./pages/_gmail');
require ('./pages/_wp-campaigns');
require ('./import.js');

$(document).ready(function () {
    $('body')
        .on('click', 'button[data-comparison-remove]', function () {
            let id = String($(this).data('comparisonRemove'));
            let idsStr = $('#compare-ids').val() || $('#bulk-action-ids').val();
            let idsArr = idsStr.split(',');

            let idIndexInArr = idsArr.indexOf(id);
            if(idIndexInArr !== -1){
                idsArr.splice(idIndexInArr, 1)
            }
            idsStr = idsArr.join(',');
            $('#compare-ids').val(idsStr);
            callRenderComparison(idsStr)
        })
        .on('click', 'button[data-comparison-mark-diff]', function () {
            if(! confirm("Are you sure? Those contacts will not appeared in duplicates list together")){
                return false;
            }

            let idsStr = $('#compare-ids').val() || $('#bulk-action-ids').val();

            $.request('onBulkAction', {
                data: {
                    action: "markDifferent",
                    ids: idsStr
                },
                flash: 1,
                success: function (message) {
                    this.success(message);

                    myCustomEventDispatch('onMarkDifferentComplete', {
                        idsStr: idsStr
                    })
                },
                error(jqXHR, text, error){
                    $.oc.flashMsg({
                        class: 'error',
                        text: jqXHR.responseJSON['X_OCTOBER_ERROR_MESSAGE']
                    });
                }
            });

            $("#comparisonModal").modal('hide');
        })

        .on('click', 'button[data-comparison-merge]', function () {
            callRenderModalMerge($(this))
        })

        .on('keypress', 'input[data-currency-convert]', function (e) {
            if(isNaN(+e.key) && e.key !== '.') {
                e.preventDefault();
                return false;
            }
        })

        .on('input', 'input[data-currency-convert]', function () {

            let resultElementId = $(this).data('currencyConvert');
            let currencySelectorId = $(this).data('currencyFrom');

            let $resultEl = $(`#${resultElementId}`);
            let $currencySelector = $(`#${currencySelectorId}`);

            let inputAmount = +$(this).val();
            let curencyName = $currencySelector.val();
            let curencyRate = +$currencySelector.find('option:selected').data('rate');

            let amount = inputAmount / curencyRate;

            $resultEl.val(Math.round(amount));
        })

        .on('change', 'select[data-trigger]', function () {
            let triggerEvent = $(this).data('trigger');
            let triggerSelector = $(this).data('triggerFor');
            let $triggerEl = $(`${triggerSelector}`);
            $triggerEl.trigger(triggerEvent)
        })

        .on('change', 'input.auto-file-submit', function (e) {
            if(! $(this)[0].files.length){ return; }
            $(this).closest('form').submit();
        })

        .on('change', 'form input.auto-save', function (e) {
            $(this).closest('form').trigger('submit')
        })

    if($('._contact-create-form-new').length > 0){
        myCustomEventDispatch('pageLoadContactCreateForm');
    }

    $(document).on('show.bs.modal', '.modal', function () {
        var zIndex = 1040 + (10 * $('.modal:visible').length);
        $(this).css('z-index', zIndex);
        setTimeout(function() {
            $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
        }, 0);
    });
});

let userRestrictionsApp = null
$(window).on('onAfterWPSettingsTabChanged', function (e) {
    if(document.getElementById('virtual-fields-manager-vue')){
        const app = createApp(VirtualFieldsManager);
        app.use(Quasar, {
            plugins: {
                Notify
            },
            config: {
                notify: { /* look at QuasarConfOptions from the API card */ }
            },
            /*extras: [
                'material-icons'
            ],*/
            iconSet: IconSet
        })
        app.mount('#virtual-fields-manager-vue');
    }
    if(document.getElementById('phone-prefix-suggester-vue')){
        const app = createApp(PhonesPrefixSuggester);
        app.use(Quasar, {
            plugins: {
                Notify
            },
            config: {
                notify: { /* look at QuasarConfOptions from the API card */ }
            },
            /*extras: [
                'material-icons'
            ],*/
            iconSet: IconSet
        })
        app.mount('#phone-prefix-suggester-vue');
    }

    if(document.getElementById('user-restrictions-manager-vue')){
        if(userRestrictionsApp === null){
            console.log('create new app')
            userRestrictionsApp = createApp(UserRestrictionsManager);
            userRestrictionsApp.use(Quasar, {
                plugins: {
                    Notify
                },
                config: {
                    notify: { /* look at QuasarConfOptions from the API card */ }
                },
                /*extras: [
                    'material-icons'
                ],*/
                iconSet: IconSet
            })
            userRestrictionsApp.provide('bus', bus)
            userRestrictionsApp.mount('#user-restrictions-manager-vue');
        } else {
            userRestrictionsApp.mount('#user-restrictions-manager-vue')
        }
    }
})

$(window).on('entryModalShow', function (e){

    if(document.getElementById('entry-files-manager-vue')){
        const app = createApp(EntryFilesManager, {
            contactId: e.detail.contact_id,
            readOnly: document.getElementById('entry-files-manager-vue').dataset.readonly,
        });
        app.use(Quasar, {
            plugins: {
                Notify
            },
            config: {
                notify: { /* look at QuasarConfOptions from the API card */ },
            },
            iconSet: IconSet,
        })
        app.mount('#entry-files-manager-vue');
    }
});


const myCustomEventDispatch = function (eventName, detail = {}) {
    let event = new CustomEvent(eventName, { 'detail': detail });
    window.dispatchEvent(event);
}
window.myCustomEventDispatch = myCustomEventDispatch;

const callRenderComparison = function (idsStr) {
    $.request('onBulkAction', {
        data: {
            action: "renderComparison",
            ids: idsStr
        },
        complete: function () {
            inlineEditor.init();
        }
    })
}
window.callRenderComparison = callRenderComparison;

const callRenderModalMerge = function ($trigger) {
    $trigger.addClass('oc-loading').prop('disabled', true);
    let idsStr = $('#compare-ids').val() || $('#bulk-action-ids').val();

    $.request('onBulkAction', {
        data: {
            action: "renderModalMerge",
            ids: idsStr
        },
        complete: function () {

            if($('#comparisonModal').hasClass('show')){
                $('#comparisonModal').one('hidden.bs.modal', function () {
                    $('#basicModal').modal('show');
                    $trigger.removeClass('oc-loading').prop('disabled', false);
                    myCustomEventDispatch('onRenderModalMergeComplete', {
                        idsStr: idsStr
                    });
                });

                $('#comparisonModal').modal('hide');
            } else {
                $trigger.removeClass('oc-loading').prop('disabled', false);
                myCustomEventDispatch('onRenderModalMergeComplete', {
                    idsStr: idsStr
                });
            }
        }
    })
}
window.callRenderModalMerge = callRenderModalMerge;

window.utils = utils;


APIv2.init(function () {

    window.APIv2 = APIv2;

    myCustomEventDispatch('APIv2Ready');

    createWSConnection()
})




function createWSConnection() {

// Создает WebSocket - подключение.
    const socket = new WebSocket(APIv2.socketURL);

// Соединение открыто
    socket.addEventListener('open', function (event) {
        socket.send(JSON.stringify({
            action: 'hello',
            activity: 'contacts-general',
            user_id: APIv2.me.id,
            token_part: APIv2.token.substr(0,10)
        }));
    });

// Наблюдает за сообщениями
    socket.addEventListener('message', function (event) {

        var evObj = JSON.parse(event.data);
        switch (evObj.event) {
            case "journal.updated":
                // evObj.data.workspace_id

                if(APIv2.workspace.id === evObj.data.workspace_id){
                    myCustomEventDispatch('journal.update', evObj.data)
                }

                break;

            default:
                console.log('Message from server ', evObj);
                break;
        }

    });
}


$(document).on('ajaxSetup', function(event, context) {
    // Enable AJAX handling of Flash messages on all AJAX requests
    context.options.flash = true

    // Enable the StripeLoadIndicator on all AJAX requests
    context.options.loading = $.oc.stripeLoadIndicator

    // Handle Error Messages by triggering a flashMsg of type error
    context.options.handleErrorMessage = function(message) {
        $.oc.flashMsg({ text: message, class: 'error' })
    }

    // Handle Flash Messages by triggering a flashMsg of the message type
    context.options.handleFlashMessage = function(message, type) {
        $.oc.flashMsg({ text: message, class: type })
    }

})

$(window).on('ajaxConfirmMessage', function(event, message) {
    if (!message) return

    Swal.fire({
        title: utils.i18n('messages.confirm-action'),//'Are you sure?',
        text: message,
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: utils.i18n('messages.yes'),
        showCloseButton: true,
    }).then((result) => {
        if (result.isConfirmed) {
            event.promise.resolve()
        } else {
            event.promise.reject()
        }
    })

    // Prevent the default confirm() message
    event.preventDefault()
    return true
})
